import { createAction, handleActions } from 'redux-actions'
import Agent from '../api/Agent'

export const setOnboardingUserID = createAction('SET_ONBOARDING_USER')
export const setStep1Status = createAction('SET_STEP1_STATUS')
export const setStep2Status = createAction('SET_STEP2_STATUS')
export const setStep3Status = createAction('SET_STEP3_STATUS')
export const setStep4Status = createAction('SET_STEP4_STATUS')
export const resetProgressBar = createAction('RESET_PROGRESS_BAR')
export const setCurrentStep = createAction('SET_CURRENT_STEP')

const initialState = {
	step1Status: 1,
	step2Status: 1,
	step3Status: 1,
	step4Status: 1,
	currentStep: 1,
	user_id: '',
}

export default handleActions(
	{
		RESET_PROGRESS_BAR: () => initialState,
		SET_CURRENT_STEP: (state, action) => ({ ...state, currentStep: action.payload }),
		SET_STEP1_STATUS: (state, action) => ({ ...state, step1Status: action.payload }),
		SET_STEP2_STATUS: (state, action) => ({ ...state, step2Status: action.payload }),
		SET_STEP3_STATUS: (state, action) => ({ ...state, step3Status: action.payload }),
		SET_STEP4_STATUS: (state, action) => ({ ...state, step4Status: action.payload }),
		SET_ONBOARDING_USER: (state, action) => ({ ...state, user_id: action.payload }),
	},
	initialState
)

export const checkProgressBarStatus = (props) => {
	return function (dispatch, getState) {
		Agent.getOnboardingStatus().then((response) => {
			if (response.ok) {
				if (response.data) {
					response.data.map((step) => {
						dispatch(setOnboardingUserID(step.user_id))

						switch (step.step) {
							case 1:
								return dispatch(setStep1Status(step.completed ? 3 : 2))
							case 2:
								return dispatch(setStep2Status(step.completed ? 3 : 2))
							case 3:
								return dispatch(setStep3Status(step.completed ? 3 : 2))
							case 4:
								return dispatch(setStep4Status(step.completed ? 3 : 2))
						}
					})
				}
			}
		})
	}
}

export const setProgressBarCurrentStep = (step) => {
	return function (dispatch) {
		dispatch(resetProgressBar())
		dispatch(setCurrentStep(step))
	}
}
